import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../models/api-response.model';
import { NotificacionTipoDto } from '../models/notificacion-tipo.model';
import { AuthService } from './auth.service';
import { BaseApiService } from './api-base.service';
import { ConfigService } from './config.service';
import { ConfigClientService } from './configClient.service';
import { SINERGIAL_ROUTES } from '../constants/api-sinergial-routes';

const DEFAULT_PARAMS = {
  pageNumber: -1,
  Orden: 3,
  IdsEmpresas: 1,
} as const;

@Injectable({ providedIn: 'root' })
export class NotificacionTipoService extends BaseApiService<ApiResponse<NotificacionTipoDto[]>> {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    authService: AuthService,
    configClientService: ConfigClientService,
  ) {
    super(http, configService, configClientService, authService);
  }

  getTipos(
    extra?: Record<string, string | number | boolean>,
  ): Observable<ApiResponse<NotificacionTipoDto[]>> {
    return this.get<ApiResponse<NotificacionTipoDto[]>>(SINERGIAL_ROUTES.NOTIFICACION_TIPO.PATH_BASE, {
      params: { ...DEFAULT_PARAMS, ...extra },
    });
  }
}
